export const diagramFactorCalculator = (deafultDiagramSizes: number) => {

    const windowSize = window.innerHeight;
    // Appframe: 32 , SecondaryNav: 44, 2*2px gap, Container Frame: 2 * 12 = 148
    const targetDiagramSize = +((windowSize - 148) * 0.60).toFixed(1);
    const factor: number = +(targetDiagramSize / deafultDiagramSizes).toFixed(2);

    return factor;
};